import { SEG_CMP } from 'src/store/ActionTypes';
import CONSTANTS from 'src/store/constants';

const INITIAL_STATE = {
  segments: [],
  clusters: [],
  fetchSegmentsStatus: undefined,
  editSegmentStatus: undefined,
};

// eslint-disable-next-line default-param-last
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SEG_CMP.UNSET:
      return {
        ...state,
        [action.payload]: undefined,
      };
    case SEG_CMP.FETCH_SEGMENTS:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.STARTED,
        segments: [],
        clusters: [],
      };
    case SEG_CMP.FETCH_SEGMENTS_SUCCEEDED:
      return {
        ...state,
        segments: action.payload.segments,
        clusters: action.payload.clusters,
        fetchSegmentsStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_CMP.FETCH_SEGMENTS_FAILED:
      return {
        ...state,
        fetchSegmentsStatus: CONSTANTS.API.FAILED,
      };
    case SEG_CMP.EDIT_SEGMENT:
      return {
        ...state,
        editSegmentStatus: CONSTANTS.API.STARTED,
      };
    case SEG_CMP.EDIT_SEGMENT_SUCCEEDED:
      return {
        ...state,
        segments: state.segments.map((segment) =>
          segment.id === action.payload.id ? { ...segment, ...action.payload.payload } : segment
        ),
        editSegmentStatus: CONSTANTS.API.SUCCEEDED,
      };
    case SEG_CMP.EDIT_SEGMENT_FAILED:
      return {
        ...state,
        editSegmentStatus: CONSTANTS.API.FAILED,
      };
    default:
      return state;
  }
};
